import React from "react";
import "./FastGamesPageStyle.scss";
import { fastGamesTextContent } from "./constant";
import MainLayout from "../../components/MainLayout";
import BannerSection from "../../components/BannerSection";
import ContactUsSection from "../../components/ContactUsSection";
import ProvidersSection from "../../components/ProvidersSection";
import EventSection from "../../components/EventSection";
import GamesWeOfferSection from "../../components/GamesWeOfferSection";
import FastCasinoGameDevelopmentServicesSection from "../../components/FastCasinoGameDevelopmentServicesSection";
import FastCasinoSoftwareSection from "../../components/FastCasinoSoftwareSection";
import FastCasinoGameDevelopmentSuperiorSection from "../../components/FastCasinoGameDevelopmentSuperiorSection";
import TrustAndExcellenceSection from "../../components/TrustAndExcellenceSection";
import OurFastCasinoGameDevelopmentServicesSection from "../../components/OurFastCasinoGameDevelopmentServicesSection";
import CertifiedSection from "../../components/CertifiedSection";
import TakingNextLevelSection from "../../components/TakingNextLevelSection";
import FastGamesSection from "../../components/FastGamesSection";

const FastGamesPage = () => {
  return (
    <MainLayout>
      <div className="fast-games-page">
        <BannerSection />
        <ProvidersSection />
        <EventSection />
        <GamesWeOfferSection />
        <FastCasinoGameDevelopmentServicesSection />
        <FastCasinoSoftwareSection />
        <FastCasinoGameDevelopmentSuperiorSection />
        <TrustAndExcellenceSection />
        <OurFastCasinoGameDevelopmentServicesSection />
        <CertifiedSection />
        <TakingNextLevelSection />
        <FastGamesSection />
        <ContactUsSection />
      </div>
    </MainLayout>
  );
};

export default FastGamesPage;
